import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, EmptyState, RowsSkeletonLoader } from '@node-space/ui-components'
import { Lottie } from 'components/Animations/SimpleLottie'
import { RewardsProduct } from 'types/rewards'
import { formatAmount, formatAPY } from '../utils'
import { RewardsAsset } from './RewardsAsset'

interface RewardsAssetsProps {
  assets: RewardsProduct[]
  isLoading: boolean
  hasNoWallets?: boolean
  onSeeDetails: (currency: string) => void
  onAddWallet: () => void
}

const MOCKED_AVAILABLE_AMOUNT = 100000 // TODO: Remove this once the API is implemented

export const RewardsAssets = ({
  assets,
  isLoading,
  hasNoWallets,
  onSeeDetails,
  onAddWallet,
}: RewardsAssetsProps) => {
  const { t } = useTranslation()

  if (isLoading) {
    return <RowsSkeletonLoader rows={5} />
  }

  if (hasNoWallets) {
    return (
      <EmptyState
        testId="rewards-assets-no-wallets-empty-state"
        LottiePlayer={<Lottie src="welcome" />}
        title={t('rewards.noWalletsState.title')}
        description={t('rewards.noWalletsState.description')}
        PrimaryButton={
          <Button onClick={onAddWallet}>{t('rewards.noWalletsState.addWallet')}</Button>
        }
      />
    )
  }

  return (
    <Box className="grid grid-cols-1 md:grid-cols-[355px_355px_auto] gap-6">
      {assets?.map(product => (
        <RewardsAsset
          key={product.currency}
          currency={product.currency}
          apyRate={formatAPY(product.earningRate)}
          availableAmount={formatAmount(MOCKED_AVAILABLE_AMOUNT)}
          onSeeDetails={() => onSeeDetails(product.currency)}
        />
      ))}
    </Box>
  )
}
